// This function takes community orders which is a dictionary of each order placed
// for this distribution location as the argument.  Each location, distribution location
// or community host is key with the values being that locations orders.  It combines multiple
// orders that were placed by the same user and creates a new dictionary that
// copies the data from the community orders and adds a foodDict and farmDict for
// easier use when trying to print out the message.  It writes the text out as html
// which is later converted to a word doc by another function.
export default function CreateDownloadLocationList(
  sortedPickupLocations,
  customerFoodListPerLocation,
  // showFridgeAndFreezerButton
) {
  // This stores each order string separately so we can use them later
  // to make the grids.
  const ordersData = [];
  // The list of orders in Grid format.
  let downloadCommunityOrderString = `<div><table style="width: 100%; border-collapse: collapse;">`;
  // Cycle through the keys and add them.

  Object.keys(sortedPickupLocations).forEach((distributionLocation) => {
    Object.keys(customerFoodListPerLocation[distributionLocation]).forEach(
      (pickupLocation) => {
        // This is used to put each order into a string.
        let pickupLocationOrderString = "";
        // Add the user's name, pickup location and their phone number.
        pickupLocationOrderString = pickupLocationOrderString.concat(
          `<h5 style = "font-size : 15px; margin-bottom : 5px">
                <text style = "font-weight : 400">${pickupLocation}</text>: </h5>`,
        );
        const itemCategories = ["orderedItems", "pantryItems"];

        // Handle both orderedItems and pantryItems
        itemCategories.forEach((itemCategory) => {
          if (itemCategory === "pantryItems") {
            pickupLocationOrderString = pickupLocationOrderString.concat(
              `<p style="font-size: 13px; margin: 5px 0px 0px 20px;"><u>Pantry Items:</u></p>`,
            );
          }

          // Cycle through the community orders at this pickup location.
          customerFoodListPerLocation[distributionLocation][pickupLocation][
            itemCategory
          ].forEach((food, itemNumber) => {
            // Check if food.tagList exists and has items */}
            if (food.tagList?.length > 0) {
              // The price of the item for the individual.
              let individualPrice = parseFloat(
                food.price /
                  (food.distributionQuantity / food.individualQuantity),
              );
              // The individual description of the food item for the user to know how
              // much they are purchasing.
              let individualDescription = food.individualDescription;

              // if suggestedPrice is true then we want to set the price to 0
              if (food.suggestedPrice) {
                // First add to the description the suggested Donation.
                // eslint-disable-next-line no-unused-vars
                individualDescription = individualDescription.concat(
                  " - Suggested Donation of $",
                  individualPrice,
                );
                // Then reset the prices to 0.
                individualPrice = 0.0;
              }

              // Add the packaging fee if there is one.
              if (food.packageFee > 0) {
                individualPrice += parseFloat(food.packageFee);
              }
              // Find the total cost of the item including multiple orders of this item.
              const individualPriceTotal = parseFloat(
                individualPrice * food.quantity,
              ).toFixed(2);
              // This is the individual price fixed to two decimals.
              individualPrice = individualPrice.toFixed(2);

              // The colour of the multiplier that shows the quantity of an item
              // ex. Potatoes x2
              let colourOfMultiplier = "black";

              // If the quantity is greater than 1 then make it red so it stands out more.
              if (food.quantity > 1) {
                colourOfMultiplier = "red";
              }

              // Add the food items to the order.
              pickupLocationOrderString =
                pickupLocationOrderString.concat(`<p style = "font-size: 12px; margin : 0px 0px 0px 20px;">
                                                                ${
                                                                  itemNumber + 1
                                                                }. <b><u>${
                                                                  food.item
                                                                }</u></b> -> <text style = "color : purple">${
                                                                  food.individualDescription
                                                                }</text>  <b><u style = "color : ${colourOfMultiplier}">x${
                                                                  food.quantity
                                                                }</u></b>  <i>${
                                                                  food.farmName
                                                                }</i> -- <text style = "font-size : 10px">$${individualPrice} ($${individualPriceTotal})</text>
                                                            </p>`);
            }
          });
        });

        // Add the order without the total to the ordersData
        ordersData.push(pickupLocationOrderString);
      },
    );
  });

  // If there are no orders being picked up on site then remove that pickup.  This
  // will only be done for pick up on site as other pick up locations won't exist if
  // there aren't any orders for them.
  //   if (
  //     Object.keys(communityOrdersByLocationDict["Pickup On Site"]).length === 0
  //   ) {
  //     // Remove the first element of the list which we know is Pickup On Site.
  //     listOfPickups.shift();
  //   }

  // Cycle through all the orders and add them to the
  // grid format.
  ordersData.forEach((order, index) => {
    // If the order is odd we want it on a new row.
    if (index % 2 === 0) {
      downloadCommunityOrderString += `<tr>`;
    }
    // Add the row styling, order, etc.
    downloadCommunityOrderString += `<td style="width: 50%; vertical-align: top; border: 1px solid black; padding: 5px; page-break-inside: avoid;">`;
    downloadCommunityOrderString += order;
    downloadCommunityOrderString += `</td>`;
    // If the order is even then it's the second item and is
    // the end of the row.
    if (index % 2 !== 0) {
      downloadCommunityOrderString += `</tr>`;
    }
  });
  // Finish the table.
  downloadCommunityOrderString += `</table></div>`;
  // Return both the formats in list and grid.
  return downloadCommunityOrderString;
}
